const API_KEYS = {
  recaptcha: import.meta.env.VITE_KEY_RECAPTCHA,
  addressy_key: import.meta.env.VITE_KEY_ADDRESSY_KEY,
  pusher: import.meta.env.VITE_KEY_PUSHER,
};

export { API_KEYS };
